(function () {
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  var lastMenuFocus = null;
  var closeTimer = null;

  function getMobileMenuParts() {
    return {
      toggle: document.querySelector('.mobile-nav-toggle-btn[aria-controls="MobileMenuDrawer"]'),
      drawer: document.getElementById('MobileMenuDrawer'),
      scrim: document.querySelector('.mobile-menu-scrim')
    };
  }

  function setInertState(element, shouldBeInert) {
    if (!element) return;

    if (shouldBeInert) {
      element.setAttribute('inert', '');
      try { element.inert = true; } catch (error) {}
    } else {
      element.removeAttribute('inert');
      try { element.inert = false; } catch (error) {}
    }
  }

  function getFocusable(container) {
    if (!container) return [];

    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function isMenuOpen(drawer) {
    return !!drawer && drawer.classList.contains('mobile-menu-drawer--open');
  }

  function setToggleState(toggle, isOpen) {
    if (!toggle) return;

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    var nextLabel = isOpen ? toggle.getAttribute('data-close-label') : toggle.getAttribute('data-open-label');
    toggle.setAttribute('aria-label', nextLabel || (isOpen ? 'Close menu' : 'Open menu'));
  }

  function ensureCloseButton(drawer) {
    if (!drawer || drawer.querySelector('[data-mobile-menu-close]')) return;

    var button = document.createElement('button');
    button.className = 'mobile-menu-close';
    button.type = 'button';
    button.setAttribute('aria-label', 'Close menu');
    button.setAttribute('data-mobile-menu-close', '');
    button.innerHTML = '<span>Close</span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"></path></svg>';
    drawer.insertBefore(button, drawer.firstChild);
  }

  function focusFirstDrawerControl(drawer) {
    window.setTimeout(function () {
      var focusable = getFocusable(drawer);

      if (focusable.length) {
        focusable[0].focus();
      } else if (drawer) {
        drawer.focus();
      }
    }, 20);
  }

  function openMenu() {
    var parts = getMobileMenuParts();
    if (!parts.drawer) return;

    ensureCloseButton(parts.drawer);

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    lastMenuFocus = document.activeElement;
    parts.drawer.hidden = false;
    parts.drawer.style.visibility = '';
    setInertState(parts.drawer, false);
    parts.drawer.setAttribute('aria-hidden', 'false');
    parts.drawer.setAttribute('aria-modal', 'true');

    if (parts.scrim) {
      parts.scrim.hidden = false;
      parts.scrim.classList.add('mobile-menu-scrim--open');
    }

    parts.drawer.classList.add('mobile-menu-drawer--open');
    document.documentElement.classList.add('mobile-menu-is-open');
    if (document.body) document.body.classList.add('mobile-menu-is-open');
    setToggleState(parts.toggle, true);
    focusFirstDrawerControl(parts.drawer);
  }

  function closeMenu(options) {
    var parts = getMobileMenuParts();
    if (!parts.drawer) return;

    var shouldRestoreFocus = !options || options.restoreFocus !== false;

    parts.drawer.classList.remove('mobile-menu-drawer--open');
    parts.drawer.setAttribute('aria-hidden', 'true');
    parts.drawer.setAttribute('aria-modal', 'false');
    setInertState(parts.drawer, true);

    if (parts.scrim) {
      parts.scrim.classList.remove('mobile-menu-scrim--open');
      parts.scrim.hidden = true;
    }

    document.documentElement.classList.remove('mobile-menu-is-open');
    if (document.body) document.body.classList.remove('mobile-menu-is-open');
    setToggleState(parts.toggle, false);

    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      if (!isMenuOpen(parts.drawer)) parts.drawer.hidden = true;
    }, 400);

    if (shouldRestoreFocus && lastMenuFocus && typeof lastMenuFocus.focus === 'function') {
      lastMenuFocus.focus();
    }
  }

  function toggleSubmenu(button) {
    if (!button) return;

    var panel = document.getElementById(button.getAttribute('aria-controls'));
    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !isExpanded;
    var indicator = button.querySelector('[aria-hidden="true"]');

    button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    if (indicator) indicator.textContent = nextExpanded ? '-' : '+';
    if (panel) panel.hidden = !nextExpanded;
  }

  function trapDrawerFocus(event, drawer) {
    if (event.key !== 'Tab' || !isMenuOpen(drawer)) return;

    var focusable = getFocusable(drawer);
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initDesktopDropdowns() {
    var header = document.querySelector('.site-header');
    var dropdowns = header ? Array.prototype.slice.call(header.querySelectorAll('.header-nav__item')) : [];

    function setExpanded(details) {
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function closeDropdown(details) {
      if (!details) return;
      details.removeAttribute('open');
      setExpanded(details);
    }

    function closeAllDropdowns(except) {
      dropdowns.forEach(function (details) {
        if (details !== except) closeDropdown(details);
      });
    }

    dropdowns.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      summary.addEventListener('click', function () {
        closeAllDropdowns(details);
        window.setTimeout(function () { setExpanded(details); }, 0);
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest && !event.target.closest('.header-nav__item')) closeAllDropdowns();
    });

    document.addEventListener('focusin', function (event) {
      if (event.target && event.target.closest && !event.target.closest('.header-nav__item')) closeAllDropdowns();
    });
  }

  function initMobileMenu() {
    var parts = getMobileMenuParts();
    if (!parts.drawer || !parts.toggle) return;

    ensureCloseButton(parts.drawer);
    closeMenu({ restoreFocus: false });

    parts.toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (isMenuOpen(parts.drawer)) closeMenu();
      else openMenu();
    }, true);

    if (parts.scrim) {
      parts.scrim.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu();
      }, true);
    }

    parts.drawer.addEventListener('click', function (event) {
      var submenuToggle = event.target && event.target.closest ? event.target.closest('[data-mobile-submenu-toggle]') : null;
      var closeButton = event.target && event.target.closest ? event.target.closest('[data-mobile-menu-close]') : null;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;

      if (submenuToggle) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleSubmenu(submenuToggle);
        return;
      }

      if (closeButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu();
        return;
      }

      if (link) closeMenu({ restoreFocus: false });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!isMenuOpen(parts.drawer)) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }

      trapDrawerFocus(event, parts.drawer);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDesktopDropdowns();
    initMobileMenu();
  });
})();
